import React from 'react'



class Home extends React.PureComponent {
  render() {
    return (
      <div><p>Swwet</p></div>
          )
  }
}

export default Home